import { connect } from 'react-redux';
import { assign as _assign } from 'lodash';
import { parse as qsParse } from 'qs';
import { RouterState } from 'connected-react-router';
import {formatMessage, CreateFormProps, ResetPasswordChangeModel, GlobalState, ResetPasswordQueryParameter, cleanSearchQuery } from 'src/api';
import { resetPasswordChangeFormValues } from  '../../../../api/models/ResetPasswordChange/reset-password-change.class';
import { createForm } from '../../../../api/models/Form/Form';
import MESSAGES from './ResetPasswordChangeForm.messages';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';

const getQueryParams = (location: RouterState['location']): ResetPasswordQueryParameter | undefined => {
  if (!location || (location && !location.search) || (location && location.search.length === 0)) {
    return;
  }
  const search = location && cleanSearchQuery(location.search);
  if (!search || (search && search.length === 0)) { return; }
  return qsParse(search);
}

export const ResetPasswordChangeFormComponent = createForm<ResetPasswordChangeModel, CreateFormProps<ResetPasswordChangeModel>>({
  className: 'partial-login-form my-0 mx-auto',
  dispatchData: (dispatch, values) => {
    dispatch(requestAPIActions.load<RequestApiHttpPayload>('resetPasswordChange', {
      url: '/Users/reset-password-change',
      options: {
        method: 'POST',
        data: values,
      },
    }));
  },
  formFields: resetPasswordChangeFormValues(),
  redirectTo: '/reset-password-change/succeeded',
  preSubmit: (values, state) => {
    const queryParams = state && getQueryParams(state.router.location);
    delete values.repeatPassword;
    return _assign({}, values, queryParams || {});
  },
  stateKeys: 'resetPasswordChange',
  shouldRedirect: true,
  submitButton: {
    text: formatMessage({...MESSAGES.resetPasswordChangeFormButton}),
    className: 'resetPassword-button mt-3 w-100'
  }
})();

export const ResetPasswordChangeForm = connect((state: GlobalState) => ({
  state
}))(ResetPasswordChangeFormComponent);
